import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const MileageContext = createContext({
  totalMiles: 0,
  totalDeduction: 0,
  refresh: () => {},
  nudge: () => {},
});

export function MileageProvider({ children }) {
  const [totalMiles, setTotalMiles]       = useState(0);
  const [totalDeduction, setTotalDeduction] = useState(0);

  const refresh = useCallback(() => {
    api.get("/mileage")
      .then((r) => {
        setTotalMiles(Number(r.data?.total_miles || 0));
        setTotalDeduction(Number(r.data?.total_deduction || 0));
      })
      .catch(() => {});
  }, []);

  // Optimistic instant delta — no API round-trip, syncs dashboard immediately.
  const nudge = useCallback((deltaMiles, deltaDeduction) => {
    setTotalMiles((m) => Math.max(0, m + deltaMiles));
    setTotalDeduction((d) => Math.max(0, d + deltaDeduction));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <MileageContext.Provider value={{ totalMiles, totalDeduction, refresh, nudge }}>
      {children}
    </MileageContext.Provider>
  );
}

export const useMileage = () => useContext(MileageContext);
